import { SelectAllActionTypes } from "./actionTypes";

export const fetchProductLocations = (menu_id: string) => ({
  type: SelectAllActionTypes.FETCH_SELECT_ALL_LOCATIONS_SAGA,
  payload: menu_id
});

export const fetchNewProduct = (menu_id: string, product_id: string) => ({
  type: SelectAllActionTypes.FETCH_SELECT_ALL_NEW_PRODUCT_SAGA,
  payload: { menu_id, product_id }
});

export const fetchOldProduct = (menu_id: string, product_id: string, product: any, page: number) => ({
  type: SelectAllActionTypes.FETCH_SELECT_ALL_OLD_PRODUCT_SAGA,
  payload: { menu_id, product_id, product, page }
});

export const setOldProduct = (product: any) => ({
  type: SelectAllActionTypes.SET_OLD_PRODUCT,
  payload: product
});

export const setNewProduct = (product: any, attribute_groups: any, default_attributes: any, menu_id: string, product_id: string) => ({
  type: SelectAllActionTypes.SET_SELECT_ALL_NEW_PRODUCT,
  payload: { product, attribute_groups, default_attributes, menu_id, product_id }
});

export const setSelectedLocationsAc = (selectedLocations: any[], product_id: string) => ({
  type: SelectAllActionTypes.SET_SELECT_ALL_SELECTED_LOCATIONS_SAGA,
  payload: { selectedLocations, product_id }
});

export const submitProductChanges = (menu_id: string, product_id: string, restaurant_id: string, body: any) => ({
  type: SelectAllActionTypes.SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SAGA,
  payload: { menu_id, product_id, restaurant_id, body }
});

export const clearSelectAll = () => ({
  type: SelectAllActionTypes.CLEAR_SELECT_ALL_PAGE
});

